import { render, staticRenderFns } from "./ClueDetail.vue?vue&type=template&id=6dafaebe&scoped=true"
import script from "./ClueDetail.vue?vue&type=script&lang=js"
export * from "./ClueDetail.vue?vue&type=script&lang=js"
import style0 from "./ClueDetail.vue?vue&type=style&index=0&id=6dafaebe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafaebe",
  null
  
)

export default component.exports